export default {
  getIsFetching: (state) => state.auth.isFetching,
  getUser: (state) => state.auth.user,
  isUserLogged: (state) => !!state.auth.user.id,
};
